import React from "react";

import NewExperienceSection from "@/ui/organisms/TopBar/NewExperienceSection";
import { isProdaOrJllUser } from "@/utils/userUtils";

export type ViewNewExperienceSectionParams = {
    useState: () => {
        user: { email?: string | null } | null;
        userSelectedDatabases: number[];
        newUiEnabled: boolean;
    };
    useCases: () => {
        setNewUiEnabled: (enabled: boolean) => void;
    };
    createProdaLink: (path: string, databaseIds: number[]) => string;
    createCoreUiLink: (path: string, databaseIds: number[]) => string;
};

export const createViewNewExperienceSection = ({
    useState,
    useCases,
    createProdaLink,
    createCoreUiLink,
}: ViewNewExperienceSectionParams) => {
    const ViewNewExperienceSection: React.FC = () => {
        const { user, userSelectedDatabases, newUiEnabled } = useState();
        const { setNewUiEnabled } = useCases();

        const isEligible = isProdaOrJllUser(user);

        const handleNewUiToggle = (next: boolean) => {
            setNewUiEnabled(next);
            if (next) {
                window.location.href = createCoreUiLink(
                    "/projects?newUiEnabled=true",
                    [],
                );
            } else {
                window.location.href = createProdaLink(
                    "/rr/database/list/properties?newUiEnabled=false",
                    userSelectedDatabases,
                );
            }
        };

        if (!isEligible) return null;

        return (
            <NewExperienceSection
                newUiEnabled={newUiEnabled}
                handleNewUiToggle={handleNewUiToggle}
            />
        );
    };

    return ViewNewExperienceSection;
};
